import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { fmtDate, fmtMoney } from "@/components/admin/AdminShared";

export const AdminPaymentsTab = ({ payments }) => (
  <Card className="bg-af-card border-af rounded-md overflow-x-auto">
    <table className="w-full text-sm" data-testid="admin-payments-table">
      <thead className="bg-af-subtle text-af-muted text-xs uppercase tracking-wider">
        <tr>
          <th className="text-left px-4 py-3 font-semibold">Date</th>
          <th className="text-left px-4 py-3 font-semibold">Client</th>
          <th className="text-left px-4 py-3 font-semibold">Plan</th>
          <th className="text-right px-4 py-3 font-semibold">Montant</th>
          <th className="text-left px-4 py-3 font-semibold">Statut</th>
        </tr>
      </thead>
      <tbody>
        {payments.map((p) => (
          <tr key={p.id} className="border-t border-af">
            <td className="px-4 py-3 text-af-secondary">{fmtDate(p.created_at)}</td>
            <td className="px-4 py-3 text-af-secondary">{p.user_email}</td>
            <td className="px-4 py-3 text-af-secondary capitalize">{p.plan_id}</td>
            <td className="px-4 py-3 text-right font-semibold">{fmtMoney(p.amount)}</td>
            <td className="px-4 py-3">
              {p.payment_status === "paid" ? (
                <Badge className="bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-sm">Payé</Badge>
              ) : (
                <Badge variant="outline" className="border-af text-af-muted rounded-sm">{p.payment_status}</Badge>
              )}
            </td>
          </tr>
        ))}
        {payments.length === 0 && (
          <tr><td colSpan={5} className="p-10 text-center text-af-muted text-sm">Aucun paiement enregistré.</td></tr>
        )}
      </tbody>
    </table>
  </Card>
);
